// Color
export const COLOR_1 = '#f8f4e9';
export const COLOR_2 = '#AB52C5';
export const COLOR_3 = '#e6bf5e';
export const COLOR_4 = '#f4cdff';
export const COLOR_5 = '#f4cdff';
export const COLOR_6 = '#ffffff';
export const COLOR_7 = '#ffffff';

// Mood Board Color
export const BG_PRIMARY = '#D5DADE';
export const BG_SECONDARY = '#737373';
export const BG_ALTERNATIVE = '#FFFFFF';
export const BG_OPACITY = '#323030';

export const ASSETS_PRIMARY = '#2C3F4E';
// Text Color
export const TEXT_PRIMARY = '#2C3F4E';
export const TEXT_SECONDARY = '#737373';
export const TEXT_ALTERNATIVE = '#FEFEFE';

// Music & Navigation Color
export const NAVIGATION_COLOR = '#47045b'; // Warna BG
export const ICON_NAVIGATION_COLOR = 'white'; // Warna Iconnya
